// Exit-intent popup.
// Desktop trigger: mouse leaving toward the top of the viewport (browser
// chrome / tab bar), the standard exit-intent heuristic.
// Mobile trigger (2026-09-19): there's no mouse to leave, so a ~1s delayed
// timer stands in instead — added when this popup became a 20%-off email
// capture rather than a WhatsApp nudge, since a plain offer doesn't need a
// genuine "about to leave" signal the way the old content did.
//
// Frequency cap: once shown (or dismissed), stays hidden for
// data-exit-intent-days days, stored in localStorage. Falls back to a
// once-per-session cap if localStorage is unavailable (private browsing,
// storage blocked) rather than showing on every mouse movement/page load.
(function () {
  var root = document.querySelector('[data-exit-intent]');
  if (!root) return;

  var STORAGE_KEY = 'p2d_exit_intent_last_shown';
  var days = parseInt(root.getAttribute('data-exit-intent-days'), 10) || 7;
  var shownThisSession = false;

  function storageAvailable() {
    try {
      var t = '__p2d_test__';
      window.localStorage.setItem(t, t);
      window.localStorage.removeItem(t);
      return true;
    } catch (e) {
      return false;
    }
  }
  var hasStorage = storageAvailable();

  function alreadyShownRecently() {
    if (shownThisSession) return true;
    if (!hasStorage) return false;
    var last = window.localStorage.getItem(STORAGE_KEY);
    if (!last) return false;
    var elapsedDays = (Date.now() - parseInt(last, 10)) / (1000 * 60 * 60 * 24);
    return elapsedDays < days;
  }

  function markShown() {
    shownThisSession = true;
    if (hasStorage) {
      window.localStorage.setItem(STORAGE_KEY, String(Date.now()));
    }
  }

  function open() {
    root.hidden = false;
    document.body.classList.add('exit-intent-open');
  }

  function show() {
    if (alreadyShownRecently()) return;
    open();
    markShown();
  }

  function hide() {
    root.hidden = true;
    document.body.classList.remove('exit-intent-open');
  }

  root.querySelectorAll('[data-exit-intent-dismiss]').forEach(function (el) {
    el.addEventListener('click', hide);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !root.hidden) hide();
  });

  // The form submission that captures the email is a real full-page POST
  // (Dawn's native `{% form 'customer' %}`), so the page reloads. If that
  // reload is the direct result of a successful subscribe, force the
  // popup open to show the success message — bypassing the frequency cap,
  // since this isn't an unsolicited re-show, it's a direct response to the
  // visitor's own action.
  if (root.querySelector('[data-exit-intent-just-subscribed="true"]')) {
    open();
    markShown();
    return;
  }

  var isMobile = window.matchMedia('(pointer: coarse)').matches;

  if (isMobile) {
    setTimeout(show, 1000);
  } else {
    document.addEventListener('mouseout', function (e) {
      // Mouse left the document entirely (no relatedTarget) via the top edge.
      if (!e.relatedTarget && e.clientY <= 0) {
        show();
      }
    });
  }
})();
